import React from 'react';

export default function ChromeInactive({
  width = 88,
  height = 88,
}: {
  width?: number,
  height?: number,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 88 88"
    >
      <path
        fill="#FAFAFA"
        d="M44.002 6.007S66.695 4.992 78.727 27.72H42.07s-6.918-.222-12.827 8.14c-1.698 3.51-3.523 7.126-1.475 14.251-2.95-4.98-15.66-27.032-15.66-27.032S21.074 6.905 44.001 6.007z"
      />
      <path
        fill="#F0F1F2"
        d="M77.549 63.707S67.077 83.804 41.317 82.81C44.5 77.323 59.65 51.18 59.65 51.18s3.66-5.857-.657-15.139c-2.197-3.224-4.435-6.596-11.65-8.394 5.804-.052 31.32 0 31.32 0s9.559 15.826-1.114 36.06z"
      />
      <path
        fill="#DBDEE2"
        d="M10.613 63.865S-1.619 44.783 12.13 23.048c3.173 5.487 18.323 31.63 18.323 31.63s3.268 6.09 13.485 6.999c3.894-.285 7.946-.529 13.124-5.846-2.854 5.032-15.66 27.021-15.66 27.021s-18.546.338-30.789-18.987z"
      />
      <path
        fill="#CBCED1"
        d="M41.307 83l5.156-21.438s5.665-.445 10.419-5.635C53.932 61.097 41.307 83 41.307 83z"
      />
      <path
        fill="#fff"
        d="M26.73 44.742c0-9.451 7.692-17.115 17.176-17.115 9.485 0 17.177 7.664 17.177 17.115 0 9.45-7.692 17.115-17.177 17.115-9.484-.01-17.176-7.664-17.176-17.115z"
      />
      <path
        fill="#A2AAB3"
        d="M29.605 44.74c0-7.865 6.398-14.25 14.302-14.25 7.894 0 14.302 6.375 14.302 14.25 0 7.866-6.397 14.252-14.302 14.252-7.893 0-14.301-6.386-14.301-14.251zM78.652 27.657l-21.23 6.206s-3.204-4.683-10.089-6.206c5.973-.032 31.319 0 31.319 0zM27.355 49.33C24.374 44.18 12.11 23.08 12.11 23.08l15.724 15.498s-1.613 3.31-1.008 8.045l.53 2.707z"
      />
    </svg>
  );
}
